import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import CompanyCard from "@/components/company/CompanyCard";
import { Bookmark, ArrowRight } from "@phosphor-icons/react";

export default function Bookmarks() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/bookmarks").then((r) => setItems(r.data.map((c) => ({ ...c, is_bookmarked: true })))).finally(() => setLoading(false));
  }, []);
  const onToggle = (id) => setItems((cs) => cs.filter((c) => c.id !== id));
  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-6">
        <div className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground mb-2 font-bold">Your list</div>
        <h1 className="font-display text-4xl font-bold tracking-tight flex items-center gap-3"><Bookmark size={28} weight="fill" className="text-emerald-600" /> Watchlist</h1>
        <p className="mt-2 text-muted-foreground">Companies you are actively monitoring across the deal pipeline.</p>
      </div>
      {loading ? <div className="text-muted-foreground">Loading…</div> : items.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-border p-16 text-center" data-testid="watchlist-empty-state">
          <div className="h-14 w-14 rounded-2xl bg-emerald-100 dark:bg-emerald-900/40 grid place-items-center mx-auto mb-4">
            <Bookmark size={26} weight="fill" className="text-emerald-600 dark:text-emerald-400" />
          </div>
          <div className="font-display font-bold text-foreground text-lg">Your watchlist is empty</div>
          <div className="text-sm mt-2 text-muted-foreground max-w-md mx-auto">Save companies from the dashboard to track them here — you&apos;ll get quick access to their latest metrics, docs and updates.</div>
          <Link
            to="/"
            data-testid="watchlist-browse-cta"
            className="mt-6 inline-flex items-center gap-2 h-11 px-5 rounded-md bg-slate-900 text-white hover:bg-slate-800 dark:bg-slate-100 dark:text-slate-900 dark:hover:bg-white text-sm font-semibold transition-colors"
          >
            Browse companies <ArrowRight size={15} />
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {items.map((c) => <CompanyCard key={c.id} company={c} onToggleBookmark={onToggle} />)}
        </div>
      )}
    </div>
  );
}
